import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex, FuelModal } from '@frete.com/fuel-station-react';
import useMenuEvents from 'hooks/events/useMenuEvents';
import { useGetTruckerQueriesData } from 'hooks/useGetTruckerQueriesData';
import { useGlobals } from 'hooks/useGlobals';
import { useTruckerProps } from 'hooks/useTruckerProps';
import { IPhone } from 'interfaces/profile.interface';
import React, { FC, useState } from 'react';

const WhatsAppButton: FC = () => {
  const { truckerData: data } = useGetTruckerQueriesData();

  const { user } = useGlobals();
  const { portalName, freight } = useTruckerProps();

  const { negotiationStartedEvent } = useMenuEvents();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const whatsApp: IPhone = data?.trucker?.phones?.find((phone) => phone.hasWhatsapp);

  const getCompanyName = () => user?.data?.company?.name?.replaceAll('&', 'e').replace(/[^\p{L}\p{N} ]/gu, '');

  const getCopyVip = () =>
    'Estou procurando um \n caminhoneiro e encontrei seu \n perfil de *Motorista Vip* 💎 na \n Fretebras.';

  const getCopyRegular = () => 'Estou procurando um \n caminhoneiro e encontrei seu \n perfil na *Fretebras* 🚚.';

  const extractLoadType = (texto: string): string | null => {
    const regex = /\/carga-[^/]+/g;

    const match = texto.match(regex);
    if (match && match[1]) {
      const responseString = match[1].replace(/\/carga-/, '').replace(/-/, ' ');
      return responseString.charAt(0).toUpperCase() + responseString.slice(1);
    }
    return null;
  };

  const getWhatsApplink = () => {
    const baseLink = `https://api.whatsapp.com/send/?phone=55${whatsApp?.ddd}${whatsApp?.number}`;
    const message = `&text=Olá, ${data?.trucker.name}. Tudo bem? \n\n *Sou ${
      user?.data?.name
    }, da empresa* \n *${getCompanyName()}* \n\n ${
      data?.trucker.isVip ? getCopyVip() : getCopyRegular()
    } \n\n *Você está livre para carregar?* \n Aguardo o seu contato 🤝🏽`;
    if (freight?.tag) {
      const loadType = extractLoadType(freight?.tag);

      const freightLink = `\n\n*Informações sobre o frete:* \nOrigem: ${freight?.origin.city}/${
        freight?.origin.federativeUnit
      } \nDestino: ${freight?.destination.city}/${freight?.destination.federativeUnit} ${
        loadType ? `\nTipo de Carga: ${loadType}` : ''
      } \n\nFrete: https://fretebras.com.br/${freight?.tag}`;
      return `${baseLink}${message}${freightLink}`;
    }
    return `${baseLink}${message}`;
  };

  const openWhatsApp = () => {
    window.open(encodeURI(getWhatsApplink()), '_blank');
  };

  const handleOpenWhatsApp = (event: React.MouseEvent) => {
    if (!whatsApp) {
      setIsModalOpen((state) => !state);
      negotiationStartedEvent('whatsapp_indisponivel', data);
      return;
    }
    negotiationStartedEvent('whatsapp_disponivel', data, event);
    openWhatsApp();
  };

  const handleOpenCloseModal = () => setIsModalOpen((state) => !state);

  return (
    <>
      <FuelButton
        size="small"
        variant="secondary"
        trailingIcon="whatsapp"
        trailingIconStyle="outlined"
        onlyIcon
        onClick={(event) => handleOpenWhatsApp(event)}
        data-testid="whatsapp-button"
      />
      <FuelModal
        portalName={portalName}
        isOpen={isModalOpen}
        onClose={/* istanbul ignore next */ () => handleOpenCloseModal()}
        showCloseButton
        width="sm"
      >
        <FuelFlex defaultProps={{ flexDirection: 'column' }}>
          <FuelTypography size="heading-sm" color="neutral-strong" weight="bold" spacingBottom={12}>
            Nenhum whatsapp
          </FuelTypography>
          <FuelTypography size="body-sm" color="neutral-default" weight="regular" spacingBottom={24}>
            Este motorista não possui número de whatsapp cadastrado, entre em contato por telefone.
          </FuelTypography>
          <FuelFlex defaultProps={{ justifyContent: 'flex-end' }}>
            <FuelButton variant="subtle" onClick={() => handleOpenCloseModal()} data-testid="close-modal-button">
              Cancelar
            </FuelButton>
          </FuelFlex>
        </FuelFlex>
      </FuelModal>
    </>
  );
};

export default WhatsAppButton;
